// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-button-sidebar-toggle{position:relative;overflow:visible !important}`, "",{"version":3,"sources":["webpack://./src/components/RightSidebar/RightSidebar.vue"],"names":[],"mappings":"AAKA,4BACC,iBAAA,CAEA,2BAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
